// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__UECSE","col":"styles_col__1WQbi"};